<template>
    <div :id="this.id" @contextmenu.prevent="handler($event)"
         class="sitebuilder-element-container"
         element="ButtonUserComponent"
         :data-hide-desktop="!this.internal_config.showDesktop"
         :data-hide-mobile="!this.internal_config.showMobile"
         :config-properties="JSON.stringify(internal_config)" :style="style()">


        <div
                v-bind:style="{height : height,width : width,border : border,'border-radius': radius,background: background,'box-shadow': boxShadow,}"
                class="btn-members-area">
            <div class="btn-members-area-text" @click.prevent="login()">
                <span>{{(internal_config.textLogin && internal_config.textLogin.length > 0 ? internal_config.textLogin : this.$t('ct-login'))}}</span>
            </div>
            <!-- <div>|</div> -->
            <div class="btn-members-area-text" @click.prevent="logout()">
                <span>{{(internal_config.textLogout && internal_config.textLogout.length > 0 ? internal_config.textLogout : this.$t('ct-logout'))}}</span>
            </div>
        </div>
    </div>
</template>

<script>

    import Data from './Model';
    import Resources from './Resources.vue';

    export default {
        name: 'ButtonUserComponent',
        props: ['config', 'id', 'preview'],
        components: {
            Data,
            Resources,
        },
        computed: {
            width() {
                return this.internal_config.width;
            },
            height() {
                return this.internal_config.height;
            },
            border() {
                if (typeof this.internal_config.border !== 'undefined') {
					let splitedBorder = this.internal_config.border.split(' ');

					if (typeof splitedBorder[2] !== 'undefined' && this.$globalStoreHelpers.isValidHex(splitedBorder[2])) {
						splitedBorder[2] = this.$globalStoreHelpers.hexToRGBA(splitedBorder[2]);
						this.internal_config.border = splitedBorder.join(' ');
					}
				}
				return this.internal_config.border;
            },
            boxShadow() {
                return this.internal_config.boxShadow;
            },
            radius() {
                return this.internal_config.borderRadius;
            },
            background() {
                return this.internal_config.backgroundColor;
            }
        },
        data() {
            return Data.data();
        },
        methods: {

            animation() {
                return true;
            },

            build(config) {
                this.internal_config = config;
            },

            textStyle() {
                return `font-family:  ${this.internal_config.textStyle.family};
                 font-size: ${this.internal_config.textStyle.size};
                 text-align: ${this.internal_config.textStyle.align};
                 font-weight: ${this.internal_config.textStyle.weight};
                 font-style: ${this.internal_config.textStyle.style};
                 text-decoration: ${this.internal_config.textStyle.stroke};
                 color: ${this.internal_config.textStyle.color}`;
            },
            subTextStyle() {
                return `font-family:  ${this.internal_config.subTextStyle.family};
                 font-size: ${this.internal_config.subTextStyle.size};
                 text-align: ${this.internal_config.subTextStyle.align};
                 font-weight: ${this.internal_config.subTextStyle.weight};
                 font-style: ${this.internal_config.subTextStyle.style};
                 text-decoration: ${this.internal_config.subTextStyle.stroke};
                 color: ${this.internal_config.subTextStyle.color}`;
            },
            textStyleMobile() {

                return `font-family:  ${this.internal_config.textStyle.family};
                 font-size: ${this.internal_config.textStyle.sizeMobile};
                 text-align: ${this.internal_config.textStyle.align};
                 font-weight: ${this.internal_config.textStyle.weight};
                 font-style: ${this.internal_config.textStyle.style};
                 text-decoration: ${this.internal_config.textStyle.stroke};
                 color: ${this.internal_config.textStyle.color}`;
            },
            style() {
                return `left:  ${this.internal_config.left};
				        padding-top: ${this.internal_config.paddingTop};
                padding-left: ${this.internal_config.paddingLeft};
                     z-index: ${this.internal_config.zIndex};
                padding-right: ${this.internal_config.paddingRight};
                padding-bottom: ${this.internal_config.paddingBottom};
                top: ${this.internal_config.top}`;
            },
            handler: function (e) {
                this.$root.$emit('focusElement', this);
                this.$root.$emit('handlerElement', this);
                e.stopPropagation();
                e.preventDefault();
            },

            login(){
                // console.log('login');
                this.$root.$emit('loginWebsiteUser', this);
            },

            logout(){
                // console.log('logout');
                this.$root.$emit('logoutWebsiteUser', this);
            }
        },
        created() {
            this.internal_config = window.mergeRecursive(this.props, this.$props.config);
        },
        mounted() {
            console.log('config', this.internal_config);
            this.build(this.$props.config);

            this.internal_config = window.mergeRecursive(this.props, this.$props.config);

            // console.log(this.internal_config);
            // if (this.$props.preview) {
            // 	this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');

            // 	this.$el.classList.add('preview');

            // 	let vm = this;


            // 	this.$el.addEventListener('mouseover', function () {
            // 		document.body.style.setProperty('--button-background-color--hover', vm.internal_config.backgroundColorHover);
            // 		document.body.style.setProperty('--button-text-color--hover', vm.internal_config.textColorHover);
            // 	});
            // }
        }
    }
</script>

<style scoped lang="scss">


    .btn-members-area {
        display: inline-flex;
        flex-direction: row;

        .btn-members-area-text {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            flex: 1;
            padding: 3px;
            cursor: pointer;

            span {
                display: inline;
            }
        }
    }
</style>
